<template>
    <main-layout>
        <div class="container">
            <H1 class="pageTitle">Slink Blog</H1>
           
            <div class="top40 accSettingsForm wideLimitWidth">
                <div v-for="(item, i) in blogs" :key="item" class="bottom20 blogLine">
                    <div class="">
                        <i class="fa-regular has-text-turk fa-lightbulb fa-2x"></i>
                    </div>
                    <div class="blogLineSubslink left5"><img src="@/assets/img/chevronsY.png" width="15" /><b>blog:{{item.subslink}}</b></div>
                    <div class="is-inline-block left5 top10">
                        <div class="is-size-5 has-text-yell"><b>{{item.title}}</b></div>
                        <div>{{item.description}}</div>
                        <button class="button is-small is-petBlue top10" @click="navToArticle(item.id)"><b>Read Article</b></button>
                    </div>
                </div>
            </div>
          

        </div>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
import blogs from '../../static/blogs'

export default {
  components: {
    MainLayout,
    
  }, 
  data: function() {
    return {
        blogs: []
    }
  },
  mounted: function(){
    this.blogs = blogs
  },
  methods:{
    navToArticle: function(id){
        this.$router.push('/blogarticle/' +  id);
    }   
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Blog.vue